import React from "react";
import {List} from "../modules/TeamAttendance";

export function AttendanceListPage() {
  return (
    <List />
  );
}
